import * as React from 'react';
import { useQuery } from 'react-query';
import type { Harbor } from 'contracts/harbors';
import { apiGeneral, queryBuilder } from 'services/api';

import { multiSelectorOptionsMapper, optionsMapper } from './utils';

const EMPTY_HARBORS: Harbor[] = [];

export type HarborQueryParams = Record<
  string,
  string | number | boolean | undefined
>;

export const useHarborOptions = (params: HarborQueryParams) => {
  const fetchHarbors = React.useCallback(async (): Promise<Harbor[]> => {
    const queryParams = queryBuilder(params);
    const { data } = await apiGeneral.get<Harbor[]>(
      `/harbors?${queryParams}`
    );

    return data;
  }, [params]);

  const harborsQuery = useQuery({
    queryKey: ['fetch-harbor-options', params],
    queryFn: fetchHarbors,
  });
  const harbors = harborsQuery.data ?? EMPTY_HARBORS;

  const options = React.useMemo(
    () =>
      harbors.map((harbor) => ({
        label: harbor.harbor_ets
          ? `${harbor.harbor_ets} - ${harbor.description}`
          : harbor.description,
        value: harbor.id.toString(),
      })),
    [harbors]
  );

  return {
    harbors,
    loading: harborsQuery.isLoading,
    isSuccess: harborsQuery.isSuccess,
    singleSelectOptions: options.map(optionsMapper),
    multiSelectOptions: options.map(multiSelectorOptionsMapper),
  };
};
